<template>
  <div id="user-info">
    <v-container grid-list-xl class="px-0 py-0">
      <v-layout 
        row
        wrap 
        align-center 
        justify-center
        v-for="user in userInfo"
        key="userid">
        <!-- Profile Picture -->
        <v-flex xs12 class="pt-0">
            <img class="picture-profile" :src="user.picture ? user.picture : '../../assets/NoPicture.png'" alt="" width="300" height="250">
        </v-flex>
        <!-- Firstname & Lastname -->
        <v-flex xs12 class="mx-4 mb-3">
          <div class="title mb-2">
            {{ user.firstname }}
            {{ user.lastname }}
          </div>
          <div class="caption">
            <v-icon small style="font-size: 16px;">pin_drop</v-icon>
            {{ checkLocation }}
          </div>
        </v-flex>
        <!-- Action Zone -->
        <v-flex xs12 class="mx-4 pb-0">
          <!-- Edit profile -->
          <a @click="onViewProfile" class="green--text text--darken-3">
            แก้ไขโปรไฟล์
          </a>
        </v-flex>
        <v-flex xs12 class="mx-4 pb-0">
          <!-- view profile  -->
          <div class="grey--text ">
            ดูบัญชีผู้ใช้
          </div>
        </v-flex>
        <v-flex xs12 class="mx-4 pb-0">
          <!-- change password  -->
          <user-change-password></user-change-password>
        </v-flex>
        <v-flex xs12 class="mx-4 pb-0">
          <!-- Logout menu -->
          <a @click="doLogout" class="green--text text--darken-3">
            ลงชื่อออก
          </a>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import UserChangePassword from '@/components/users/UserChangePassword'

export default {
  name: 'user-info',
  components: {
    'user-change-password': UserChangePassword
  },
  data() {
    return {}
  },
  props: {
    userInfo: {
      type: Array,
      required: true,
      validate: function(value) {
        return ['syncing', 'synced', 'version-conflict', 'error'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    checkLocation: function() {
      if (this.userInfo[0].province && this.userInfo[0].country) {
        return this.userInfo[0].province + ', ' + this.userInfo[0].country
      } else {
        return 'ไม่ได้ระบุข้อมูล'
      }
    }
  },
  methods: {
    onViewProfile(userid) {
      this.$router.push({ name: 'UserProfile', params: { userid: this.$session.get('userid') } })
    },
    doSubmit: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.editModeLoading = !this.editModeLoading
          var that = this
          const data = {
            userid: this.$session.get('userid'),
            firstname: this.userInfo[0].firstname,
            lastname: this.userInfo[0].lastname,
            phone: this.userInfo[0].phone,
            birthday: this.userInfo[0].birthday,
            email: this.userInfo[0].email
          }
          axios
            .put('https://api.farmerspace.co/marketplace/updateUserInfo', data)
            .then(response => {
              if (response.data.message === true) {
                that.editModeLoading = !that.editModeLoading
                that.editMode = !that.editMode
                iziToast.success({
                  title: 'Updated!',
                  position: 'bottomRight'
                })
              } else {
                that.loading = !that.loading // Disable loading
                console.log(response.data)
                iziToast.error({
                  title: 'Failed',
                  position: 'bottomRight'
                })
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    },
    doLogout() {
      let that = this
      swal({
        title: 'ออกจากระบบ',
        width: '16rem',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#000',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          axios
            .delete(
              'https://api.farmerspace.co/marketplace/deleteSessionLogin/' +
                that.$session.get('userid') +
                '/' +
                that.$session.get('session-id')
            )
            .then(function(response) {
              if (response.data.message === true) {
                console.log('Destroy session token successful')
              } else {
                console.log(response.data)
              }
            })
            .catch(function(error) {
              console.log(error)
            })
          that.$session.destroy()
          that.$router.push({ name: 'UserLogin' })
          iziToast.info({
            title: 'Logout Successful!',
            message: 'Thank you for visiting us',
            position: 'bottomRight'
          })
        } else if (result.dismiss === swal.DismissReason.cancel) {
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.toolbar-change-password {
  background-color: #252525;
}
.picture-profile {
  object-fit: cover;
  // border-radius: 50%;
}

.image-box {
  position: relative;
  width: 100%;
}

.edit-image {
  object-fit: cover;
  border-radius: 50%;
  opacity: 1;
  width: 150px;
  height: 150px;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.image-box:hover .image {
  opacity: 0.3;
}

.image-box:hover .middle {
  opacity: 1;
}
a {
  &:hover {
    color: #376235 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/users/UserInfo.vue